<template>
    <!-- Start Copy Right Area  -->
    <div class="copyright-area copyright-style-one">
        <div class="container copyright-style-one-con">
            <div class="row align-items-center">
				<div class="col-lg-6 col-md-4 col-sm-12 col-12">
				    <div class="copyright-left text-center text-lg-start">
				        <p class="copyright-text">版权所有 © 2022博信诚（北京）网络科技有限公司  <a href="https://beian.miit.gov.cn" target="_blank">京ICP备16063465号-1</a> </p>
				    </div>
				</div>
                <!-- <div class="col-lg-6 col-md-8 col-sm-12 col-12">
                    <div class="copyright-right">
                        <ul class="ft-menu link-hover">
                            <li>
                                <router-link to="/call-us">网站地图</router-link>
                            </li>
                            <li>
                                <router-link to="#">隐私政策</router-link>
                            </li>
                            <li>
                                <router-link to="#">法律申明</router-link>
                            </li>
							<li>
							    <router-link to="/call-us">联系我们</router-link>
							</li>
                        </ul>
                    </div>
                </div> -->
                
            </div>
        </div>
    </div>
    <!-- End Copy Right Area  -->
</template>

<script>
    export default {
        name: 'Copyright'
    }
</script>